import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetPointCentralClientMappingRequest = {
  buildingId: number
  clientId: string
}

type GetPointCentralClientMappingResponse = {
  isSynced: boolean
}

export const getPointCentralClientMappingQueryKey = (data: GetPointCentralClientMappingRequest) => [
  'useGetPointCentralClientMapping',
  data,
]

const getPointCentralClientMapping = async (data: GetPointCentralClientMappingRequest) => {
  const response = await authAPI.get<GetPointCentralClientMappingResponse>(
    `/building/${data.buildingId}/point-central/client-mapping/${data.clientId}`,
  )
  return response.data
}

export const useGetPointCentralClientMapping = (data: GetPointCentralClientMappingRequest) =>
  useQuery({
    enabled: Boolean(data.buildingId) && Boolean(data.clientId),
    queryFn: () => getPointCentralClientMapping(data),
    queryKey: getPointCentralClientMappingQueryKey(data),
  })
